<template>
	<section class="blocks" id="block4" :style="{ background: bg_color }">
		<div class="container">
			<h2 class="title-box">{{ title }}</h2>
			<article>

				<div v-html="content">
					{{ content }}
				</div>

				<figure>
					<img :src="figure" :alt="title">
				</figure>

			</article>
		</div>
	</section>
</template>

<script>
    export default {
        props: ["title", "content", "figure", "bg_color"]
    }
</script>

<style lang="scss">
	#block4 {

		article {
			text-align: center;

			p {
				color: #222831;
				font-size: 1.6em;
				line-height: 24px;
				margin-bottom: 25px;
				text-align: center;
			}
		}

		figure {
			padding: 40px 0;
			text-align: center;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/blocks/Block4.vue